import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useDeleteWebhook(shop: ShopDto) {
	return useApiMutation(
		"delete",
		"/shops/{shopId}/webhooks/{webhookId}",
		{
			invalidate: useInvalidateShop(shop.id),
			mapVariables: (webhookId: string) => ({
				params: { path: { shopId: shop.id, webhookId } },
			}),
		},
	);
}
